import { render } from "./DashboardOnboardingSteps.vue?vue&type=template&id=0fc26d85"
import script from "./DashboardOnboardingSteps.vue?vue&type=script&lang=js"
export * from "./DashboardOnboardingSteps.vue?vue&type=script&lang=js"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__